import { useState } from "react";

import { useRouter } from "next/router";

import PropTypes from "prop-types";

import { useGetProductReview } from "@/api/client/product";
import HorizontalLine from "@/components/data-display/horizontalLine";
import ProductReview from "@/components/data-display/product-review";
import Rating from "@/components/data-display/rating";
import Pagination from "@/components/navigation/pagination";

function ProductReviewSection({ data }) {
  const [page, setPage] = useState(1);
  const [reviews, setReviews] = useState(data);
  const [isPaginating, setPaginating] = useState(false);

  const {
    query: { product_slug },
  } = useRouter();

  const {
    meta,
    average_rating,
    total_review_count,
    reviews: reviewList,
  } = reviews || {};

  useGetProductReview({
    enabled: isPaginating,
    query: { product_slug, page },
    onSuccess: (data) => {
      setReviews((prevState) => ({ ...prevState, ...data }));
    },
  });

  const handlePagination = (page) => {
    setPage(page + 1);
    if (!isPaginating) setPaginating(true);
  };

  return (
    <section>
      <div className="mb-[2.313rem] ">
        <div className="space-y-[1.125rem]">
          <h3 className="text-[1.25rem] font-semibold text-grayDisplay-900">
            Reviews {total_review_count > 0 && `(${total_review_count})`}
          </h3>
          <span className="block text-[0.938rem] text-grayDisplay-850">
            Get specific details about this product from customers who own it.
          </span>
        </div>

        {reviewList?.length > 0 && (
          <div className="mt-[2.25rem] space-y-[1.125rem]">
            <p className="text-grayDisplay-850">Overall Review</p>
            <div className="flex items-center space-x-[1.25rem]">
              <Rating
                ratingNumber={average_rating}
                starClassName="w-[1.313rem] h-[1.213rem]"
              />
              <p className="text-[1.125rem] text-grayDisplay-700">
                {average_rating} out of 5.00
              </p>
            </div>
          </div>
        )}
      </div>

      {reviewList && reviewList?.length > 0 ? (
        <>
          <HorizontalLine className="my-[2.5rem]" />
          <div className="space-y-[1.875rem]">
            {reviewList?.map((reviewData, index) => (
              <div key={index} className="space-y-[1.875rem]">
                <ProductReview reviewData={reviewData} />
                <HorizontalLine />
              </div>
            ))}
          </div>

          {meta?.total > meta?.per_page && (
            <div className="mt-[3rem] flex justify-center lg:justify-start">
              <Pagination
                getPaginateData={handlePagination}
                initialPage={meta.current_page - 1}
                totalPage={Math.ceil(meta.total / meta.per_page)}
              />
            </div>
          )}
        </>
      ) : (
        <p className="mb-[2rem] text-center text-2xl font-bold">
          This product has no reviews.
        </p>
      )}
    </section>
  );
}

ProductReviewSection.propTypes = {
  data: PropTypes.shape({
    average_rating: PropTypes.number,
    max_rating: PropTypes.number,
    total_review_count: PropTypes.number,
    meta: PropTypes.object,
    reviews: PropTypes.array,
  }),
};

export default ProductReviewSection;
